import { ESortOrder, TSortOrder } from 'types/pagination.types';

export const parseStringToOrder = (orderString: string): 'asc' | 'desc' | undefined => {
  if (orderString === 'asc') {
    return 'asc';
  } else if (orderString === 'desc') {
    return 'desc';
  }
  return undefined;
};

export const parseOrderToOrderString = (order: TSortOrder): 'asc' | 'desc' | undefined => {
  if (order === ESortOrder.ASC) {
    return 'asc';
  } else if (order === ESortOrder.DESC) {
    return 'desc';
  }
  return undefined;
};
